import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import DocumentMeta from 'react-document-meta';
import coverageImageDefault from './coverage.png';

import config from '../config';

const meta = {
  title: 'Coverage | Free medication abortion',
  description: '',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '',
    },
    property: {
      'og:title': 'Covergae | Free medication abortion',
      'og:description': '',
      'og:image': '',
    },
  },
};

export default function Coverage() {
  const [cmsData, setCmsData] = useState({});
  const [coverageImage, setCoverageImage] = useState();
  useEffect(() => {
    const fetchCoverageImage = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/item/CoverageImage`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result.CoverageImage && result.CoverageImage.path) {
          console.log(`${config.assetsBaseUrl}/${result.CoverageImage.path}`);
          setCoverageImage(
            `${config.assetsBaseUrl}/${result.CoverageImage.path}`,
          );
          setCmsData(result);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        //
      }
    };

    fetchCoverageImage();
  }, []);

  return (
    <DocumentMeta {...meta}>
      <div className="coverage-page">
        <div className="page-title dark-background text-start contact-bg">
          <div className="container position-relative">
            <h1>{cmsData.title}</h1>
          </div>
        </div>

        <section className="coverage section light-background py-4">
          <div className="container section-title pb-0">
            <div
              className="col-lg-12 content section-title pb-3 cms-content"
              dangerouslySetInnerHTML={{ __html: cmsData.content || '' }}
            ></div>
          </div>
        </section>

        <section className="covergae section light-background py-4">
          <div className="text-center">
            <img src={coverageImage ?? coverageImageDefault} width="90%" />
          </div>
        </section>
      </div>
    </DocumentMeta>
  );
}
